import { render, staticRenderFns } from "./dfm-pjsc-unclaimed-dividends.vue?vue&type=template&id=ea256b7e"
import script from "./dfm-pjsc-unclaimed-dividends.vue?vue&type=script&lang=js"
export * from "./dfm-pjsc-unclaimed-dividends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/unclaimed-dividends-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fdfm-pjsc-unclaimed-dividends.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/unclaimed-dividends-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fdfm-pjsc-unclaimed-dividends.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default})
